__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "@nackle/deck";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@nackle/biw-web-router", "2.0.5", () => (Promise.all([__webpack_require__.e(240), __webpack_require__.e(979), __webpack_require__.e(558)]).then(() => (() => (__webpack_require__(7240))))));
			register("@nackle/bridge", "3.0.43", () => (Promise.all([__webpack_require__.e(54), __webpack_require__.e(979), __webpack_require__.e(823)]).then(() => (() => (__webpack_require__(3673))))));
			register("@nackle/origami-icons", "1.7.31", () => (Promise.all([__webpack_require__.e(708), __webpack_require__.e(979)]).then(() => (() => (__webpack_require__(3708))))));
			register("@nackle/origami", "2.58.4", () => (Promise.all([__webpack_require__.e(930), __webpack_require__.e(426), __webpack_require__.e(979), __webpack_require__.e(113)]).then(() => (() => (__webpack_require__(7426))))));
			register("@nackle/umbrella", "2.1.36", () => (Promise.all([__webpack_require__.e(930), __webpack_require__.e(213), __webpack_require__.e(979), __webpack_require__.e(439)]).then(() => (() => (__webpack_require__(7213))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(143), __webpack_require__.e(979)]).then(() => (() => (__webpack_require__(8143))))));
			register("react", "18.3.1", () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(758))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};